import { render, staticRenderFns } from "./IconSvgPinned.vue?vue&type=template&id=79e9f2d7&scoped=true&"
import script from "./IconSvgPinned.vue?vue&type=script&lang=js&"
export * from "./IconSvgPinned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9f2d7",
  null
  
)

export default component.exports